import { rpcController } from "../rpc";
import { cacheResource } from "kea-resource";
import { ParamsEficienciaEAD } from "app/models/requireme";

const controller = rpcController("EficienciaEAD");

/**Resource del reporte de estadísticas de clientes*/
export const RepEficienciaEAD = cacheResource({
Generar: async (
parametros: ParamsEficienciaEAD): Promise<string> =>
await controller("GenerarReporteEficienciaEAD", {}, parametros)
}, {
}, {
})


// WEBPACK FOOTER //
// ./app/resources/items/eficienciaead.tsx